import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

export function formatApiError(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

// Defaults; can be overridden at runtime by /api/site/info
export const SITE_DEFAULTS = {
  phone: "+91 75502 64658",
  whatsapp: "917550264658",
  email: "care@hitechrealty.in",
  address:
    "Door No. 3B1, 3rd Floor, No. 1, J P Tower, Nungambakkam High Rd, Tirumurthy Nagar, Nungambakkam, Chennai, Tamil Nadu 600034",
};

export const CHENNAI_LOCALITIES = [
  "OMR", "ECR", "Velachery", "Anna Nagar", "Adyar",
  "Tambaram", "Porur", "Sholinganallur", "T. Nagar",
];

export function waLink(message, number) {
  const num = number || SITE_DEFAULTS.whatsapp;
  const text = encodeURIComponent(message);
  return `https://wa.me/${num}?text=${text}`;
}

export const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_7b12f01a-24ee-463d-8f8d-8c78ba3949d9/artifacts/bc5qrn02_WhatsApp%20Image%202025-08-01%20at%2015.01.28.jpeg";

export function fileUrl(path) {
  if (!path) return "";
  if (path.startsWith("http")) return path;
  return `${BACKEND_URL}${path}`;
}

export function loadRazorpayScript() {
  return new Promise((resolve) => {
    if (window.Razorpay) return resolve(true);
    const s = document.createElement("script");
    s.src = "https://checkout.razorpay.com/v1/checkout.js";
    s.onload = () => resolve(true);
    s.onerror = () => resolve(false);
    document.body.appendChild(s);
  });
}
